import { downloadXlsxTemplate } from './downloadXlsxTemplate';

const CENTRAL_USER_HEADERS = ['username', 'password', 'full_name', 'role', 'email', 'active'];

const centralUserExampleRows = () => [
  ['demo_operator', 'Password123#', 'Demo Operator', 'operator', 'operator@example.com', 'YES'],
  ['demo_superadmin', 'Password123#', 'Demo Superadmin', 'superadmin', 'superadmin@example.com', 'YES'],
];

export const downloadCentralUserImportTemplate = () => {
  downloadXlsxTemplate({
    filename: 'template_import_pengguna_cpanel.xlsx',
    headers: CENTRAL_USER_HEADERS,
    rows: centralUserExampleRows(),
    sheetName: 'pengguna_cpanel',
  });
};

const HOSPITAL_USER_HEADERS = [
  'username',
  'password',
  'nama_lengkap',
  'email',
  'role',
  'nik',
  'jabatan',
];

export const downloadHospitalUserImportTemplate = () => {
  downloadXlsxTemplate({
    filename: 'template_import_pengguna_rumah_sakit.xlsx',
    headers: HOSPITAL_USER_HEADERS,
    rows: [
      [
        'user_demo',
        'Password123#',
        'Nama Lengkap Demo',
        'user@example.com',
        'Nama Group (sesuai role di RS)',
        '1234567890123456',
        'Staff',
      ],
    ],
    sheetName: 'pengguna_rs',
  });
};

export const downloadTenantImportTemplate = () => {
  downloadXlsxTemplate({
    filename: 'template_import_tenant.xlsx',
    headers: ['slug', 'description', 'kode_verifikasi'],
    rows: [['rsud-contoh', 'Rumah Sakit Contoh', 'RSUD2026']],
    sheetName: 'tenant',
  });
};
